import { SidebarProvider } from '@src/app/layout';
import { Box } from '@src/shared/ui/layout';

import Main from './Main';
import Sidebar from './Sidebar';

const StyleSheet = {
  root: {
    display: 'flex',
    minHeight: '100vh',
  },
};

function Navigation() {
  return (
    <Box component="nav">
      <Sidebar />
    </Box>
  );
}

export default function App() {
  return (
    <SidebarProvider>
      <Box sx={StyleSheet.root}>
        <Navigation />
        <Main />
      </Box>
    </SidebarProvider>
  );
}
